var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('AppHeader'),_c('router-view'),(_vm.$route.path === '/')?[_c('HeroSection'),_c('AboutSection'),_c('AdvantagesSection'),_c('PartnersSection'),_c('StrategySection')]:_vm._e(),_c('AppFooter')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }